import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, Modal, Row} from "reactstrap";
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import inspectionImage from '../../assets/img/banner/inspection.png'
import HorizontalLine from "../Widget/HorizontalLine";
import MyCardImage from "../Card/MyCardImage";
import WarningLabel from "../Widget/WarningLabel";
import {_DONE, _PASS, INSPECTION_STATUS_COLOR} from "../../utils/Global";

/*= (message, okCallback, cancelCallback) =>*/
export default class CreateReleaseVerificationConfirmModal extends BaseComponent{

    constructor(props){
        super(props);
        let {inspection} = this.props
        if(!inspection){
            inspection = {}
        }
        this.state = {
            inspection,
            referenceCode:undefined,
            errorMessage:undefined,
        }
    }
    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props){
            let {inspection} = props
            if(!inspection){
                inspection = {}
            }
            this.setState({
                inspection,
                referenceCode:undefined,
                errorMessage:undefined,
            })
        }
    }


    render(){
        let {inspection, referenceCode, errorMessage} = this.state
        let {onClickOk, onClickCancel} = this.props
        let {inspectionStatus} = inspection
        if(!inspectionStatus){
            inspectionStatus = {}
        }
        if(!onClickOk){
            onClickOk = () => {}
        }
        if(!onClickCancel){
            onClickCancel = () => {}
        }

        let model = inspection.model?inspection.model:{}
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="md"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <CardHeader><h3>{label.ReleaseCreation}</h3></CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <MyCardImage style={{padding:'32px', width:'80%'}} src={inspectionImage}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col>
                                    <h3>
                                        <strong>
                                            {model.systemType}
                                        </strong>
                                    </h3>
                                    <span>{label.WithReference}</span>
                                    <h2 className="text-secondary bold"><strong>{inspection.reference}</strong></h2>
                                    <span>{label.HaveBeen}</span>
                                    <h2 className="text-primary bold" style={{color:INSPECTION_STATUS_COLOR[inspectionStatus.name]}}>
                                        <strong>{label(inspectionStatus.name)}</strong>
                                    </h2>
                                    <WarningLabel message={errorMessage} show={errorMessage}/>
                                    <br/>
                                    <strong style={{color:'brown'}}>
                                        {label.AreYouAboutReleasingThisItem}
                                    </strong>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        block
                                        color={"danger"}
                                        onClick={() => {
                                            onClickCancel()
                                        }}>
                                        {label.Close}
                                    </Button>
                                </Col>
                                {
                                    (inspectionStatus.id ==_PASS || inspectionStatus.id===_DONE)&&(
                                        <Col style={{textAlign:'right'}}>
                                            <Button
                                                block
                                                onClick={() => {
                                                    onClickOk(inspection)
                                                }}>
                                                {label.CreateRelease}
                                            </Button>
                                        </Col>

                                    )
                                }
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

CreateReleaseVerificationConfirmModal.propTypes = {
    inspection:PropTypes.any.isRequired,
    show:PropTypes.bool.isRequired,
    onClickOk:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired,
}
